import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import MailIcon from '@mui/icons-material/Mail';
import PhoneIcon from '@mui/icons-material/Phone';
import OrcidIcon from 'components/Icons/OrcidIcon';
import PdfIcon from '@mui/icons-material/PictureAsPdf';

export const DOWNLOADABLE_SOCIALS = [
    'cv'
]

export const ICONS_BY_SOCIAL_NAME = {
    facebook: FacebookIcon,
    linkedin: LinkedInIcon,
    mail: MailIcon,
    orcid: OrcidIcon,
    phone: PhoneIcon,
    cv: PdfIcon
}